const BellIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.2681 29C18.4436 29.304 18.6961 29.5565 19.0001 29.732C19.3041 29.9075 19.649 29.9999 20.0001 29.9999C20.3511 29.9999 20.696 29.9075 21 29.732C21.3041 29.5565 21.5565 29.304 21.7321 29"
        stroke="#663497"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.262 23.326C11.1314 23.4692 11.0452 23.6472 11.0139 23.8385C10.9826 24.0298 11.0075 24.226 11.0857 24.4034C11.1639 24.5807 11.2919 24.7316 11.4543 24.8375C11.6166 24.9434 11.8062 24.9999 12 25H28C28.1938 25.0001 28.3834 24.9438 28.5459 24.8381C28.7083 24.7324 28.8365 24.5817 28.9149 24.4045C28.9933 24.2273 29.0185 24.0311 28.9874 23.8398C28.9564 23.6485 28.8704 23.4703 28.74 23.327C27.41 21.956 26 20.499 26 16C26 14.4087 25.3679 12.8826 24.2426 11.7574C23.1174 10.6321 21.5913 10 20 10C18.4087 10 16.8826 10.6321 15.7574 11.7574C14.6321 12.8826 14 14.4087 14 16C14 20.499 12.589 21.956 11.262 23.326Z"
        stroke="#663497"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BellIcon;
